import React from "react";
import { UiRootCustomStyled, UiRootCustomStyledProps } from "./styles";

export type UiRootCustomProps = React.PropsWithChildren<React.AllHTMLAttributes<HTMLDivElement>> &
  UiRootCustomStyledProps;

export const UiRootCustom: React.FC<UiRootCustomProps> = props => {
  return <UiRootCustomStyled {...props} />;
};
